import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '@/layout'
Vue.use(Router)
//cv以下代码解决路由地址重复的报错问题(一劳永逸)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [
    {
      path: "/",
      redirect: '/index',
      component: Layout,  // 此处承接了所有后台页面公用的 头部、底部、侧栏等等
      children: [
        {
          path: '/index',
          component: () => import('@/views/index'),
          name:'index'
        },
        {
          path: '/error/404',
          component: () => import('@/views/404')
        },
        {
          path: "/category/:id?/:page?",
          component: () => import("@/views/category/_id/_page.vue"),
          name:'category'
        },
        {
          path: "/product/:id",
          component: () => import("@/views/product/_id.vue"),
          name:'product'
        },
        {
          path: "/news/:id?/:page?",
          component: () => import("@/views/news/_id/_page.vue"),
          name:'news'
        },
        {
          path: "/detail/:id",
          component: () => import("@/views/detail/_id.vue"),
          name:'detail'
        },
        {
          path: "/gallerys/:id?/:page?",
          component: () => import("@/views/gallerys/_id/_page.vue"),
          name:'gallerys'
        },
        {
          path: "/gallery/:id",
          component: () => import("@/views/gallery/_id.vue"),
          name:'gallery'
        },
        {
          path: "/contact",
          component: () => import("@/views/contact.vue")
        },
        {
          path: "/:id",
          component: () => import("@/views/_id.vue")
        },
      ]
    },
    // 404 page must be placed at the end !!!
    { path: '*', redirect: '/error/404', hidden: true }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js